import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['login'];

  randomize() {
    if (this.hasLoginTarget) {
      this.loginTarget.value = this.#newLogin();
      this.loginTarget.dispatchEvent(new Event("change")); // trigger change event to notify any listeners (e.g., FormDirtyConfirmNavigationController)
    }
  }

  #newLogin() {
    // Generate a random login string of 8 characters
    // Duplicates User.compute_unique_login
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let login = '';
    for (let i = 0; i < 8; i++) {
      login += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return login;
  }
}
